import WarrantiesPage from "./WarrantiesPage";

export default WarrantiesPage;
